export class TipoViagem {
  ativo: boolean;
  id: number;
  tipo: string;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/tipos-viagem/shared/tipo-viagem.model.ts
 **/